import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const TennisLessons = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my tennis lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps tennis lessons businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for tennis lessons businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most tennis lessons businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my tennis lessons business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like tennis lessons. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Tennis Lessons - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Tennis Lessons CRM", url: "/industries/tennis-lessons" }
  ];

  const industryData = {
    name: 'Tennis Lessons & Coaching',
    title: 'Fill Your Court Time & Build Long-Term Students',
    subtitle: 'Automate lesson booking, track skill progression, and keep students improving year-round',
    icon: '🎾',
    challenges: [
      'Court time not fully utilized',
      'Students quit mid-season',
      'Group class enrollment fluctuates',
      'Hard to track individual progress',
      'Summer camps don\'t fill'
    ],
    solutions: [
      'Online court booking optimization',
      'Student retention programs',
      'Group class promotion automation',
      'Skill progression tracking',
      'Summer camp marketing'
    ],
    features: [
      'Student CRM with skill levels',
      'Court booking system',
      'Skill progression tracking',
      'Group class management',
      'Tournament registration',
      'Video analysis sharing',
      'Package management',
      'Review requests'
    ],
    results: [
      '90% court utilization',
      '75% student retention',
      'Fill 100% of summer camps',
      '5.3K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Tennis Lessons UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for tennis lessons businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for tennis lessons UK, tennis lessons business software, tennis lessons customer management, tennis lessons lead generation UK"
        url="/industries/tennis-lessons"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default TennisLessons;